function startCountdown() {
  document.querySelectorAll('.announcement-time-end').forEach(function(el) {
    let endTime = parseInt(el.getAttribute('data-time'), 10) * 1000;
    let countdownEl = el.querySelector('.announcement-countdown');

    function updateTimer() {
      let now = Date.now();
      let distance = endTime - now;

      if (distance <= 0) {
        countdownEl.textContent = "00:00:00";
        clearInterval(timer);
        return;
      }

      let hours = Math.floor(distance / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      countdownEl.textContent =
        String(hours).padStart(2, '0') + ":" +
        String(minutes).padStart(2, '0') + ":" +
        String(seconds).padStart(2, '0');
    }

    let timer = setInterval(updateTimer, 1000);
    updateTimer();
  });
}


(function ($) {
  $(document).ready(function () {
    if ($('.announcement-running-line').length) {
      $('.announcement-running-line__slider')
        .on('beforeStarting', function() {
          $(this).closest('.announcement-running-line').addClass('m-run');
        })
        .marquee({
          speed: 20,
          direction: 'left',
          startVisible: true,
          pauseOnHover: false,
          duplicated: true
        });
    }

    if ($('.announcement-time-end').length) {
      startCountdown();
    }
  });
})(jQuery);
